/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MeterStandType = {
    Ok: 'Ok',
    Estimated: 'Estimated',
    Deleted: 'Deleted',
    Missing: 'Missing',
    NotApplicable: 'NotApplicable',
    Calculated: 'Calculated',
    NotSpecified: 'NotSpecified',
} as const;
export type MeterStandType = typeof MeterStandType[keyof typeof MeterStandType];

